globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.FormValueTrigger = (function() {

  FormValueTrigger.selector = '[data-plugin="form-trigger"]';

  function FormValueTrigger($html) {
    this.$html            = $html;
    this.$triggerInput    = $(`[name="${$html.data("trigger-input")}"]`);
    this.triggerValue     = $html.data("trigger-value");
    this.init();
  }

  FormValueTrigger.init = function($html) {
    $html.find(FormValueTrigger.selector).each(function(){
      new FormValueTrigger($(this));
    })
  }

  FormValueTrigger.prototype = {
    init: function() {
      var _this = this;

      _this.toggleDisplay(_this.$triggerInput.val());
      _this.events();
    },
    toggleDisplay: function(value) {
      var _this = this;

      if(value == _this.triggerValue) {
        _this.$html.fadeIn();
        _this.$html.removeClass("display-none");
      } else {
        _this.$html.fadeOut();
        _this.$html.addClass("display-none");
      }
    },
    events: function() {
      var _this = this;

      _this.$triggerInput.on("change", function() {
        _this.toggleDisplay($(this).val());
      });
    }
  }

  return FormValueTrigger;

})();
